(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('PatientStatusSearch', PatientStatusSearch);

    PatientStatusSearch.$inject = ['$resource'];

    function PatientStatusSearch($resource) {
        var resourceUrl =  'api/_search/patient-statuses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
